import type { ScheduleTranslation } from './schedule.en'

export const scheduleKo: ScheduleTranslation = {
  common: {
    after: `후`,
    cancel: `취소`,
    clear: `지우기`,
    closed: `닫힘`,
    create: `만들기`,
    daily: `매일`,
    delete: `삭제`,
    deleteError: {
      inUseGeneric: `이 일정은 스위치보드에서 사용 중이어서 삭제할 수 없습니다. 스위치보드에서 제거한 뒤 다시 시도해 주세요.`,
      inUseMultiple: `이 일정은 다음 스위치보드에서 사용 중이어서 삭제할 수 없습니다: {{switchboardNames}}. 해당 스위치보드에서 제거한 뒤 다시 시도해 주세요.`,
      inUseSingle: `이 일정은 다음 스위치보드에서 사용 중이어서 삭제할 수 없습니다: {{switchboardNames}}. 해당 스위치보드에서 제거한 뒤 다시 시도해 주세요.`,
      listWithMore: `{{visibleNames}} 외 {{remaining}}개`,
    },
    description: `설명`,
    edit: `수정`,
    from: `부터`,
    holiday: `휴일`,
    monthly: `매월`,
    name: `이름`,
    never: `안 함`,
    onDate: `날짜 지정`,
    routing: `라우팅`,
    save: `저장`,
    saving: `저장 중...`,
    timeZone: `시간대`,
    to: `까지`,
    validationErrorTitle: `유효성 검사 오류`,
    weekdayShort: {
      fri: `금`,
      mon: `월`,
      sat: `토`,
      sun: `일`,
      thu: `목`,
      tue: `화`,
      wed: `수`,
    },
    weekdayLong: {
      fri: `금요일`,
      mon: `월요일`,
      sat: `토요일`,
      sun: `일요일`,
      thu: `목요일`,
      tue: `화요일`,
      wed: `수요일`,
    },
    weekly: `매주`,
    yearly: `매년`,
  },
  detail: {
    actions: {
      deleteScheduleModalTitle: `일정 삭제`,
      deleteScheduleTitle: `일정 삭제`,
      editScheduleTitle: `일정 수정`,
    },
    currentRouting: `현재 라우팅:`,
    error: `오류`,
    header: {
      breadcrumbCurrent: `일정 수정`,
      breadcrumbRoot: `일정`,
    },
    hoursView: {
      calendar: `캘린더`,
      list: `목록`,
    },
    loading: `일정 불러오는 중...`,
    notFound: {
      description: `찾으시는 일정이 존재하지 않습니다.`,
      title: `일정을 찾을 수 없습니다`,
    },
    toast: {
      createOverrideFailedTitle: `오버라이드 생성 실패`,
      createWeeklyHoursFailedTitle: `주간 시간 생성 실패`,
      deleteEventFailedTitle: `이벤트 삭제 실패`,
      deleteScheduleFailedTitle: `일정 삭제 실패`,
      eventDeleted: `이벤트가 삭제되었습니다`,
      eventsUpdatedDescription: `{{count}}개 이벤트의 시간대가 업데이트되었습니다`,
      eventsUpdatedTitle: `이벤트 업데이트됨`,
      failedTitle: `실패`,
      genericError: `오류가 발생했습니다`,
      holidaysAddFailed: `휴일 {{count}}개 추가 실패`,
      holidaysAddedSuccess: `휴일 {{count}}개가 추가되었습니다`,
      holidaysAddedWithFailures: `휴일 {{successCount}}개 추가 성공 ({{errorCount}}개 실패)`,
      loadEventsFailedDescription: `이벤트를 불러오는 중 오류가 발생했습니다`,
      loadEventsFailedTitle: `일정 이벤트를 불러오지 못했습니다`,
      loadScheduleFailedDescription: `일정을 불러오는 중 오류가 발생했습니다`,
      loadScheduleFailedTitle: `일정을 불러오지 못했습니다`,
      overrideCreated: `오버라이드가 생성되었습니다`,
      overrideUpdated: `오버라이드가 업데이트되었습니다`,
      scheduleDeleted: `일정이 삭제되었습니다`,
      scheduleUpdated: `일정이 업데이트되었습니다`,
      successTitle: `성공`,
      updateOverrideFailedTitle: `오버라이드 업데이트 실패`,
      updateScheduleFailedTitle: `일정 업데이트 실패`,
      updateWeeklyHoursFailedTitle: `주간 시간 업데이트 실패`,
      weeklyHoursCreated: `주간 시간이 생성되었습니다`,
      weeklyHoursUpdated: `주간 시간이 업데이트되었습니다`,
    },
  },
  holidays: {
    actions: {
      addWithCount: `휴일 추가 ({{count}})`,
    },
    common: {
      unknown: `알 수 없음`,
    },
    customPrompt: {
      link: `직접 특별 시간 설정하기`,
      prefix: `찾는 휴일이 없나요?`,
    },
    empty: `사용 가능한 사전 설정 휴일이 없습니다`,
    error: {
      failedToLoad: `휴일을 불러오지 못했습니다`,
    },
    loading: `휴일 불러오는 중...`,
    modal: {
      description: `오버라이드 목록에 추가할 휴일 프리셋을 선택하세요. 생성 후 이벤트를 수정해 각 휴일 시간을 조정할 수 있습니다.`,
      title: `프리셋 휴일 추가`,
    },
    submitting: `일정을 업데이트하는 중입니다. 잠시만 기다려 주세요.`,
    table: {
      holiday: `휴일`,
      nextOccurrence: `다음 발생일`,
    },
    validation: {
      noneSelectedDescription: `추가할 휴일을 하나 이상 선택해 주세요`,
      noneSelectedTitle: `선택된 휴일이 없습니다`,
    },
  },
  list: {
    card: {
      lastUpdated: `마지막 업데이트`,
    },
    common: {
      notAvailable: `해당 없음`,
    },
    delete: `삭제`,
    deleteTitle: `일정 삭제`,
    empty: `일정을 찾을 수 없습니다`,
    grid: {
      errorTitle: `오류`,
    },
    hoursVary: `시간 변동`,
    loading: `일정 불러오는 중...`,
    newSchedule: `새 일정`,
    noPermission: `일정에 접근할 권한이 없습니다.`,
    noSchedules: `일정을 찾을 수 없습니다`,
    noSchedulesDescription: `새 일정 추가를 눌러 가용 시간을 설정해 보세요`,
    pagination: {
      all: `전체`,
      jumpToPage: `{{page}}페이지로 이동`,
      nextPage: `다음 페이지`,
      previousPage: `이전 페이지`,
      resultsPerPage: `페이지당 결과:`,
    },
    status: {
      closed: `닫힘`,
      holiday: `휴일`,
      openNow: `현재 영업 중`,
    },
    subtitle: `일정 구성을 조회하고 관리합니다`,
    title: `일정`,
    toast: {
      createFailed: `생성 실패`,
      createFailedDescription: `일정을 생성하지 못했습니다`,
      createSuccess: `일정 생성됨`,
      createSuccessDescription: `일정이 성공적으로 생성되었습니다.`,
      deleteFailed: `삭제 실패`,
      deleteFailedDescription: `일정을 삭제하지 못했습니다`,
      deleteSuccess: `일정 삭제됨`,
      deleteSuccessDescription: `일정이 성공적으로 삭제되었습니다.`,
    },
    unavailable: `사용 불가`,
  },
  modal: {
    create: {
      cancel: `취소`,
      defaultWeeklyHoursLabel: `기본 주간 시간 포함`,
      descriptionLabel: `설명`,
      descriptionPlaceholder: `이 일정에 대한 선택 설명`,
      nameLabel: `이름`,
      namePlaceholder: `영업 시간`,
      saveSchedule: `일정 저장`,
      saving: `저장 중...`,
      timeZoneLabel: `시간대`,
      title: `새 일정`,
      validationNameRequired: `일정 이름을 입력해 주세요`,
      validationTitle: `검증`,
    },
    deleteConfirmation: {
      cancel: `취소`,
      confirm: `삭제`,
      defaultBodyWithItemPrefix: `정말로 `,
      defaultBodyWithItemSuffix: ` 을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
      defaultBodyWithoutItem: `이 항목을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
      defaultTitle: `항목 삭제`,
    },
    editSchedule: {
      applyTimezoneChanges: `시간대 변경 적용 대상:`,
      customEventsHelp: `기존 사용자 지정 이벤트의 시간대를 업데이트하지 않으려면 이 옵션을 해제하세요.`,
      customEventsWithCount: `사용자 지정 이벤트 ({{count}})`,
      descriptionPlaceholder: `이 일정에 대한 선택 설명`,
      namePlaceholder: `영업 시간`,
      timezoneWarning: `주간 시간이 선택한 시간대로 업데이트됩니다.`,
      title: `일정 수정`,
      updateSchedule: `일정 업데이트`,
      validation: {
        nameRequired: `일정 이름을 입력해 주세요`,
      },
    },
    override: {
      dateTime: `날짜 및 시간`,
      dateType: {
        multipleDays: `여러 날`,
        singleDay: `단일 날짜`,
      },
      endRepeat: `반복 종료`,
      irregularRepeat: `이 오버라이드는 불규칙 반복 패턴을 사용하여 수정할 수 없습니다`,
      irregularRepeatNamed: `{{name}}에는 수정할 수 없는 반복 패턴이 있습니다.`,
      irregularRepeatNextOccurrence: `다음 발생일은 {{occurrence}}입니다`,
      holidayTemplateCheckPending: `{{name}} 반복 패턴을 확인하고 있습니다. 날짜 및 반복 컨트롤은 일시적으로 사용할 수 없습니다.`,
      holidayTemplateCheckUnavailable: `{{name}} 반복 패턴을 확인할 수 없습니다. 날짜 및 반복 컨트롤은 사용할 수 없습니다.`,
      loadingDetails: `오버라이드 세부 정보 불러오는 중...`,
      monthly: {
        nthWeekday: `{{nth}}{{suffix}}번째 {{weekday}}`,
        specificDate: `{{day}}{{suffix}}일`,
      },
      namePlaceholder: `오버라이드 이름`,
      startTimeAriaLabel: `시작 시간`,
      startDateAriaLabel: `시작 날짜`,
      endDateAriaLabel: `종료 날짜`,
      endRepeatDateAriaLabel: `반복 종료 날짜`,
      endTimeAriaLabel: `종료 시간`,
      timePlaceholder: `h:mm`,
      meridiemAriaLabel: `{{label}} 오전/오후`,
      meridiemOptionsAriaLabel: `{{label}} 오전/오후 옵션`,
      timeOptionsAriaLabel: `{{label}} 옵션`,
      occurrences: `회`,
      repeat: `반복`,
      repeatEvery: `반복 간격`,
      repeatOn: `반복 요일`,
      repeatUnit: {
        days: `일`,
        months: `개월`,
        weeks: `주`,
        years: `년`,
      },
      timeType: {
        closedAllDay: `하루 종일 닫힘`,
        setClosedHours: `닫힘 시간 설정`,
      },
      titleCreate: `오버라이드 추가`,
      titleEdit: `일정 오버라이드 수정`,
      validation: {
        endAfterStart: `종료 날짜/시간은 시작 날짜/시간 이후여야 합니다`,
        endDateRequired: `여러 날 이벤트의 종료 날짜를 선택해 주세요`,
        endDateRequiredShort: `종료 날짜를 선택해 주세요`,
        invalidDateTime: `유효한 날짜 및 시간을 입력해 주세요`,
        monthRequired: `연간 반복을 위한 월을 선택해 주세요`,
        monthlyPatternRequired: `월간 반복 패턴을 선택해 주세요`,
        nameRequired: `오버라이드 이름을 입력해 주세요`,
        occurrencesRequired: `반복 횟수를 입력해 주세요`,
        startEndTimeRequired: `시작 및 종료 시간을 선택해 주세요`,
        validDayRequired: `유효한 날짜를 선택해 주세요 (1-31)`,
        validWeekdayPatternRequired: `유효한 요일 패턴을 선택해 주세요`,
        weekdayRequired: `요일을 하나 이상 선택해 주세요`,
      },
      yearly: {
        nthWeekday: `{{month}}의 {{nth}}{{suffix}}번째 {{weekday}}`,
        specificDate: `{{month}} {{day}}{{suffix}}일`,
      },
    },
  },
  overrides: {
    actions: {
      addHoliday: `휴일 추가`,
      addOverride: `오버라이드 추가`,
    },
    empty: `설정된 일정 오버라이드가 없습니다`,
    item: {
      deleteHolidayTitle: `휴일 삭제`,
      deleteOverrideModalTitle: `오버라이드 삭제`,
      deleteOverrideTitle: `오버라이드 삭제`,
      editOverrideTitle: `오버라이드 수정`,
      overrideInEffect: `오버라이드 적용 중`,
      repeatsPrefix: `반복`,
    },
    title: `일정 오버라이드`,
  },
  status: {
    closed: `닫힘`,
    holiday: `휴일`,
    open: `열림`,
  },
  weeklyHours: {
    calendar: {
      confirmCreateDescription: `선택한 시간 범위로 새 일정 항목을 생성하시겠습니까?`,
      confirmCreateTitle: `일정 항목 생성`,
      confirmDeleteTitle: `시간 슬롯 삭제`,
      deleteEventLabel: `{{day}} {{time}} 삭제`,
    },
    table: {
      confirmDeleteDayDescription: `{{day}}의 모든 시간 슬롯을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
      confirmDeleteDayItem: `{{day}} 주간 시간`,
      confirmDeleteDayTitle: `시간 슬롯 삭제`,
      confirmDeleteSlotItem: `{{day}} 시간 슬롯`,
      confirmDeleteSlotTitle: `시간 슬롯 삭제`,
      days: {
        friday: `금요일`,
        monday: `월요일`,
        saturday: `토요일`,
        sunday: `일요일`,
        thursday: `목요일`,
        tuesday: `화요일`,
        wednesday: `수요일`,
      },
      slot: {
        addTitle: `일정 항목 추가`,
        addDayLabel: `{{day}} 시간 추가`,
        deleteTitle: `일정 항목 삭제`,
        deleteSlotLabel: `{{day}} {{start}}~{{end}} 시간 삭제`,
        endPlaceholder: `종료`,
        startPlaceholder: `시작`,
        startTimeLabel: `{{day}} 시작 시간`,
        startTimeLabelNumbered: `{{day}} 시작 시간, 항목 {{number}}`,
        endTimeLabel: `{{day}} 종료 시간`,
        endTimeLabelNumbered: `{{day}} 종료 시간, 항목 {{number}}`,
        unavailable: `사용 불가`,
      },
      toggle: {
        disableDay: `{{day}} 비활성화`,
        enableDay: `{{day}} 활성화`,
      },
    },
    timeSelect: {
      noTimesFound: `해당 시간이 없습니다`,
    },
  },

  queryError: {
    fetchSchedules: `일정을 가져오지 못했습니다`,
    fetchSchedule: `일정을 가져오지 못했습니다`,
    fetchEvents: `일정 이벤트를 가져오지 못했습니다`,
    fetchHolidays: `일정 휴일을 가져오지 못했습니다`,
    createSchedule: `일정을 만들지 못했습니다`,
    updateSchedule: `일정을 업데이트하지 못했습니다`,
    createEvent: `일정 이벤트를 만들지 못했습니다`,
    updateEvent: `일정 이벤트를 업데이트하지 못했습니다`,
    deleteEvent: `일정 이벤트를 삭제하지 못했습니다`,
    generic: `문제가 발생했습니다. 다시 시도하세요.`,
  },
}
